import { useState } from "react";
import { ConfirmModal } from "../../../Modals/ConfirmModal";
import { ToastManager } from "../../../common/ToastContainer";
import { SESSION_AUTH } from "../../../../helpers/auth";
import { useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import FullPageProgress from "../../../common/FullPageProgress";

const EventOrgazinationTeamRemove = (props) => {
  const { onUpdate, member } = props;
  const [deleteTeam, setDeleteTeam] = useState(false);
  const { accountId } = useParams();
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [loader, setLoader] = useState(false);

  const ondeleteAccept = () => {
    //onUpdate()
    setDeleteTeam(false);
    setLoader(true);
    EVENTS_SERVICES.removeOrgTeam({
      userId: userSession.userId,
      id: accountId,
      memberId: member?.userId?._id,
    })
      .then((data) => {
        if (data.code === 200) {
          ToastManager.addToast(data?.message);
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  return (
    <>
      {loader && <FullPageProgress />}
      <button
        type="button"
        onClick={() => {
          setDeleteTeam(true);
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
      >
        Remove Access
      </button>

      {member && deleteTeam && (
        <ConfirmModal
          title="Remove Access"
          message={`<p> <b> ${member?.userId?.name} </b> <br/>${member?.userId?.email}</p>   Are you sure? `}
          request={deleteTeam}
          cancel={() => {
            setDeleteTeam(false);
          }}
          accept={ondeleteAccept}
        />
      )}
    </>
  );
};

export default EventOrgazinationTeamRemove;
